import 'regenerator-runtime/runtime';
import { takeEvery } from 'redux-saga/effects';

import {
  BausteinAuswahlStatus,
  Produktlinienname,
  TaasRsData,
  TaasRsVmData,
  TaasTarifrisikoschluesselRS,
} from '@ps20/bff-models';
import { App, Produktlinie } from '@ps20-frontend/frontend-models';
import { ForkEffect } from '@redux-saga/core/effects';
import { GlobalActions, ShopTarifierungRequestEvents } from '@ps20-frontend/shop-integration-redux';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { ShopTarifierer, ShopTarifierungsErgebnisHandler } from '@ps20-frontend/preis-lib';
import { IAppState } from '../appState';
import { selectSelectedProduktlinie } from '../../app/shared/selectors/produkt.selector';
import { generateBasicTaasRSVmData } from './transformer/rsVmData.transformer';

export const shopTarifierungsErgebnisHandler = new ShopTarifierungsErgebnisHandler<
  IAppState,
  TaasRsVmData
>(App.RS_VERMIETUNG);
export const shopTarifierer = new ShopTarifierer({
  appId: App.RS_VERMIETUNG,
  taasDataBuilder: buildTaasRsDataForShop,
  resultHandler: shopTarifierungsErgebnisHandler,
});

export function* shopTarifierungVmRS(): Generator<ForkEffect> {
  yield takeEvery(
    ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_RS_VM,
    safeSaga(shopTarifierer.handleSuccess, App.RS_VERMIETUNG),
  );
  yield takeEvery(
    GlobalActions.TARIFIERE_ANGEBOT_FOR_SHOP,
    safeSaga(shopTarifierer.callTarifierung, App.RS_VERMIETUNG),
  );
}

export function buildTaasRsDataForShop(state: IAppState): TaasRsData {
  const rsData: TaasRsData = generateBasicTaasRSVmData(state);
  const bausteinAuswahlStatusArray: BausteinAuswahlStatus<TaasTarifrisikoschluesselRS>[] = [];
  bausteinAuswahlStatusArray.push({
    schluessel: TaasTarifrisikoschluesselRS.VERMIETER,
    ausgewaehlt: true,
    isGefahr: false,
    isInklusiv: true,
    anzahlVorschaeden: rsData.anzVorschaeden,
  });

  if (state.vertragsoptionen.beibehalten) {
    const selectedProduktlinie: Produktlinie = selectSelectedProduktlinie(state);
    bausteinAuswahlStatusArray[0].deltafaktor = selectedProduktlinie.zusatzoptionen[0].deltafaktor;
    bausteinAuswahlStatusArray[0].plzFaktor = selectedProduktlinie.zusatzoptionen[0].plzFaktor;
    bausteinAuswahlStatusArray[0].bausteinAnpassungsfaktor =
      selectedProduktlinie.zusatzoptionen[0].bausteinAnpassungsfaktor;
  }
  rsData.salesProducts = {};
  rsData.salesProducts[Produktlinienname.KOMFORT] = bausteinAuswahlStatusArray;
  return rsData;
}
